import { render, staticRenderFns } from "./LoadAffirm.vue?vue&type=template&id=abedb30a&scoped=true"
import script from "./LoadAffirm.vue?vue&type=script&lang=js"
export * from "./LoadAffirm.vue?vue&type=script&lang=js"
import style0 from "./LoadAffirm.vue?vue&type=style&index=0&id=abedb30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abedb30a",
  null
  
)

export default component.exports